import React, { FormEvent, useState } from "react"

import { IconFailure } from "components/core/Icons"

import * as S from "./Input.styles"

export interface InputProps {
  hasError?: boolean
  name: string
  value?: string
  placeholder: string
  type?: string
  errorMessage?: string
  onChange: (e: FormEvent<HTMLInputElement>) => void
}

export const Input = ({
  hasError,
  value = "",
  name,
  placeholder,
  type,
  errorMessage,
  onChange,
}: InputProps) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <S.InputContainer>
      <S.Input
        aria-label={name}
        hasError={hasError}
        placeholder={placeholder}
        type={type ?? "text"}
        value={value}
        onChange={onChange}
      />
      {hasError && (
        <S.Alert
          onMouseOut={() => setShowTooltip(false)}
          onMouseOver={() => setShowTooltip(true)}
        >
          <IconFailure />
          <S.Tooltip isVisible={showTooltip}>{errorMessage}</S.Tooltip>
        </S.Alert>
      )}
    </S.InputContainer>
  )
}
